import {
  getStaticNewsProps,
  NewsHub,
  NEWS_TYPES_INVESTORS,
} from '@dreamstack/feature-components'
import 'twin.macro'
import { getStaticPropsPlus } from '../../lib/next/getStaticPropsPlus'
import { defaultQueries } from '../../lib/shared/defaultQueries'

export default function NewsHubPage() {
  return <NewsHub newsTypes={NEWS_TYPES_INVESTORS} />
}

export const getStaticProps = getStaticPropsPlus({
  getQueries: async () => [...defaultQueries],
  getProps: getStaticNewsProps,
})
